<template>
  <b-container class="h-100">
    <transition name="slide-fade">
      <b-row class="h-100">
        <b-col
          class="d-flex flex-column justify-content-center login-wrapper--right-form"
        >
          <div class="d-flex">
            <b-img src="/img/logo.svg" fluid />
          </div>

          <div class="mt-4">
            <h3 class="font-weight-bold">Change Password</h3>
            <p class="mt-3">
              This is your first login as business admin. Please change your
              password.
            </p>
          </div>

          <b-form @submit.prevent="onSubmit">
            <b-row no-gutters>
              <b-col cols="12">
                <b-form-group id="input-group-1">
                  <label class="font-weight-bold">New Password</label>
                  <b-form-input
                    id="input-3"
                    v-model="form.password"
                    class="form-control effect-26"
                    :class="form.password ? 'has-content' : ''"
                    type="password"
                    autocomplete="new-password"
                    required
                    placeholder="Enter new password"
                  ></b-form-input>
                  <div class="input-error" v-if="form.$getError('password')">
                    {{ form.$getError('password')[0] }}
                  </div>
                </b-form-group>
                <b-form-group id="input-group-2">
                  <label class="font-weight-bold">Confirm New Password</label>
                  <b-form-input
                    id="input-4"
                    v-model="form.password_confirmation"
                    class="form-control effect-26"
                    :class="form.password_confirmation ? 'has-content' : ''"
                    type="password"
                    autocomplete="confirm-new-password"
                    required
                    placeholder="Confirm new password"
                  ></b-form-input>

                  <div
                    class="input-error"
                    v-if="form.$getError('password_confirmation')"
                  >
                    {{ form.$getError('password_confirmation')[0] }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <div class="ta-right">
                  <b-button class="form-button" type="submit" variant="primary">
                    <b-spinner small v-if="form.$busy"></b-spinner>
                    <div v-else>PROCEED</div>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </transition>
  </b-container>
</template>

<script>
import Form from '@/utils/form'

export default {
  data() {
    return {
      form: new Form({
        password: '',
        password_confirmation: ''
      })
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/change-password', {
          password: this.form.password,
          password_confirmation: this.form.password_confirmation
        })
        .then(({ data }) => {
          this.form.$busy = false
          this.$router.replace({
            name: 'home.welcome-page'
          })
        })
        .catch(error => {
          this.form.$handleError(error)
        })
    }
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    }
  }
}
</script>
